module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "episode article"
  }, [_c('router-link', {
    staticClass: "image",
    style: ({
      backgroundImage: 'url(' + _vm.featuredImage + ')'
    }),
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.title)
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.episode.excerpt)
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "more-link",
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [_vm._v("More")])], 1), _vm._v(" "), _c('div', {
    staticClass: "playModule"
  }, [_c('div', {
    staticClass: "playButton"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Post',
        params: {
          slug: _vm.episode.slug
        }
      }
    }
  }, [(_vm.episodeNumber) ? _c('span', [_vm._v(_vm._s(_vm.episodeNumber) + " • ")]) : _vm._e(), _vm._v(_vm._s(_vm.formattedDate) + "\n        ")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c8fb57b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/EpisodeModule.vue
// module id = 776
// module chunks = 1